// initial state
import * as base from './base.js'
const baseName = '/admin'
const baseNameRule = '/admin/api/authRule'
const baseNameGroup = '/admin/system/role'
const baseNameAccess = '/admin/api/authAccess'
const baseNameType = '/admin/api/authType'

const authCheck = baseName + '/loginCheck'
const authLogin = baseName + '/loginNew'
const authGetInfo = baseName + '/getInfo'
const authLogout = baseName + '/logout'
const authUpPassword = baseName + '/system/user/resetPwd'
const authCaptchaImage = baseName + '/captchaImage'

const authRuleMainDropTree = baseNameRule + '/mainDropTree'

const obj = base.setBaseUrl('auth', baseName)
const obj1 = base.setBaseUrl('authRule', baseNameRule)
const obj2 = base.setBaseUrl('authGroup', baseNameGroup)
const obj3 = base.setBaseUrl('authAccess', baseNameAccess)
const obj4 = base.setBaseUrl('authType', baseNameType)
const a = Object.assign(obj, obj1, obj2, obj3, obj4, { authLogin, authGetInfo, authCheck, authLogout, authUpPassword, authCaptchaImage, authRuleMainDropTree })
export default a
